import { generateTestId } from "@client-shared";

export const setShopDomainModalTestId = (identifier: string): string =>
  generateTestId("ShopDomainModal", identifier);
